import React from 'react';
import Icon from '../../../components/AppIcon';

const WelcomeMessage = () => {
  const benefits = [
    {
      icon: 'Bot',
      title: 'KI-Chatbots erstellen',
      description: 'Erstellen Sie intelligente Chatbots für Ihre Websites in wenigen Minuten'
    },
    {
      icon: 'Palette',
      title: 'Individuell anpassen',
      description: 'Passen Sie das Design und Verhalten Ihrer Bots an Ihre Marke an'
    },
    {
      icon: 'Globe',
      title: 'Einfache Integration',
      description: 'Integrieren Sie Ihre Bots mit einem einfachen Embed-Code in jede Website'
    },
    {
      icon: 'BarChart3',
      title: 'Detaillierte Analysen',
      description: 'Verfolgen Sie Gespräche und optimieren Sie die Performance Ihrer Bots'
    }
  ];

  return (
    <div className="space-y-8">
      {/* Header */}
      <div className="text-center">
        <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6">
          <img 
            src="/assets/images/Kein_Titel_900_x_1024_px_2_-1757417528542.png" 
            alt="Vierdimensional Logo" 
            className="w-16 h-16 object-contain"
          />
        </div>
        <h1 className="text-3xl font-bold text-foreground mb-3 font-heading">
          Willkommen bei Vierdimensional
        </h1>
        <p className="text-lg text-muted-foreground max-w-md mx-auto">
          Erstellen Sie professionelle KI-Chatbots für Ihre Websites ohne technische Kenntnisse
        </p>
      </div>
      {/* Benefits List */}
      <div className="space-y-6">
        {benefits?.map((benefit, index) => (
          <div key={index} className="flex items-start space-x-4">
            <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
              <Icon name={benefit?.icon} size={24} className="text-primary" />
            </div>
            <div>
              <h3 className="font-semibold text-foreground mb-1">
                {benefit?.title}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {benefit?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      {/* Trust Indicators */}
      <div className="pt-6 border-t border-border">
        <div className="flex items-center justify-center space-x-6 text-xs text-muted-foreground">
          <div className="flex items-center space-x-2">
            <Icon name="Shield" size={16} className="text-success" />
            <span>DSGVO-konform</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Lock" size={16} className="text-success" />
            <span>SSL-verschlüsselt</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="MapPin" size={16} className="text-success" />
            <span>Made in Germany</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeMessage;